import type { TourConfig } from '../../types/tour.types'

// User Details (team / seats management). Anchors are `data-tour` attributes on the view
// (added alongside this tour). Context first, then the controls that manage seats and users.
// The overview cards and the Purchase Seats button are behind `v-if`s, so those steps are
// optional and skip silently when absent.
const userDetailsTour: TourConfig = {
  id: 'user-details',
  title: 'Manage your team and seats',
  module: 'Settings',
  routeName: 'UserDetails',
  order: 19,
  autoStart: true,
  steps: [
    {
      id: 'intro',
      title: 'Your team in one place',
      body: 'This is where you **manage the people on your account** — add or edit users, set their roles, and share out export and mobile credits. Keep everyone set up with exactly the access they need.',
    },
    {
      id: 'overview',
      target: '[data-tour="ud-overview"]',
      placement: 'bottom',
      // Only shown once the company overview has loaded.
      optional: true,
      title: 'Seats and credits at a glance',
      body: 'See your plan, how many **sales and lead-gen seats** are in use, and the **export and mobile credits** still unassigned — so you always know what is left to allocate.',
    },
    {
      id: 'add-user',
      target: '[data-tour="ud-add-user"]',
      placement: 'bottom',
      title: 'Add a team member',
      body: 'Use **Add User** to bring a colleague onto the account. Each user takes a seat; when you run out, free one up by removing a user or add more seats.',
    },
    {
      id: 'purchase',
      target: '[data-tour="ud-purchase"]',
      placement: 'bottom',
      // Only shown to accounts that can self-serve extra seats.
      optional: true,
      title: 'Need more seats?',
      body: 'If your plan supports it, **Purchase Seats** lets you add capacity on the spot — no need to contact support to grow your team.',
    },
    {
      id: 'table',
      target: '[data-tour="ud-table"]',
      placement: 'top',
      title: 'Edit roles and permissions',
      body: 'Every user lives here. **Edit** anyone to change their role, toggle **export, CRM and Salesforce** permissions, or activate/deactivate their access. Search by name or email to find them fast.',
    },
  ],
}

export default userDetailsTour
